module.exports = __webpack_public_path__ + "img/6m.9dc0696e.png";